import { Flex } from "@chakra-ui/react";

import { Button } from "ui/Button/Button";
import { ArrowLeftIcon } from "ui/Icons/Icons";
import { TitleS } from "ui/Typography/Typography";

type SkipStepButtonProps = {
  onClick: () => void;
  label: string;
};

export function SkipStepButton({ onClick, label }: SkipStepButtonProps) {
  return (
    <Flex w="100%" p="s200" alignItems="center" justifyContent="center">
      <Button
        variant="ghost"
        onClick={onClick}
        rightIcon={<ArrowLeftIcon boxSize={5} transform="rotate(180deg)" color="grey.800" />}
        data-testid="skip-step-button"
      >
        <TitleS>{label}</TitleS>
      </Button>
    </Flex>
  );
}
